import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from 'store/slices/api/api-slice';
import staffUserSlice from 'store/slices/staff-user/staff-user-slice';
import snackbarSlice from 'store/slices/snackbar/snackbar-slice';
import confirmationDialog from 'store/slices/confirmation-dialog/confirmation-dialog-slice';
import backdropSlice from 'store/slices/backdrop/backdrop-slice';
import categoryId from 'store/slices/toon-tint/toon-tint-category-id-slice';
import cardData from 'store/slices/cards/card/card-data-slice';

const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        staffUser: staffUserSlice,
        snackbar: snackbarSlice,
        categoryId: categoryId,
        cardData: cardData,
        confirmationDialog: confirmationDialog,
        backdropSlice: backdropSlice,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(
            apiSlice.middleware,
        ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
